module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "appetizers-all-the-young-dudes-cooking-the-foods"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "boston-bruschetta"
    }
  }, [_c('h3', [_vm._v("Boston Bruschetta")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The East Coast cannot be wrong, right? Italian cuisine combined with East Coast flavour and one of the best bands to come out of America. This tasty treat can work as an appetizer, or if you make enough, a meal on its own. It’s "), _c('strong', [_c('em', [_vm._v("More than a Feeling")])]), _vm._v(".")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "uri"
  }, [_vm._v("https://www.youtube.com/watch?v=SSR6ZzjDZ94")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.8753in",
      "height": "3.65625in"
    },
    attrs: {
      "alt": "",
      "src": "media/fil3.jpg"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Ingredients")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup finely chopped red onions or scallions")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 tablespoons of balsamic vinegar plus 1/4 cup virgin olive oil, divided")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 garlic cloves: minced")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 cans (6 ounces each) lump crabmeat, drained or same of lump lobster. (You can also use fresh or frozen crab flavoured Alaskan Pollock in a pinch).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1 cup chopped seeded plum tomatoes")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1-1/2 teaspoons minced fresh basil or 1/2 teaspoon dried basil")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("3/4 teaspoon minced fresh oregano or 1/4 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("8 slices Italian bread (1/2 inch thick) or baguettes sliced lengthwise. Personally I use Ciabatta")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/4 cup of grated parmesan cheese or mozzarella if you prefer")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("3 cups of mixed pitted olives")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Instructions")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("1. ")]), _vm._v("In a large skillet, sauté onions or scallions and 2 tablespoons oil until tender. Add garlic and cook it a minute longer. Add the crab or lobster, tomatoes, basil, and oregano; cook and stir for 5-6 minutes or until heated through. Remove it from the heat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("2. ")]), _vm._v("Brush both sides of each slice of bread with remaining oil. In another large skillet, toast bread for about 1-2 minutes on each side. Cut each slice in half if you have not done so already; top it with crab mixture.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd89e44e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0004.vue
// module id = 90
// module chunks = 0